import { getPropertySyncMode, PropertyForSyncMode } from '@common/util/property'
import { LocalStorageKey } from '~/components/hooks/useLocalStorage'
import { PropertySyncMode } from '~/graphql/generated/query.types'

export function getPropertyLabel(property: PropertyForSyncMode & { name: string }) {
  const propertySyncMode = getPropertySyncMode(property)
  const label =
    propertySyncMode === PropertySyncMode.disabled ? `${property.name} (disabled)` : property.name
  return label
}

export function buildPropertySidToDisambiguatedName<T extends { sid: string; name: string }>(
  properties: readonly T[]
): Map<string, string> {
  const nameToCount = new Map<string, number>()
  for (const property of properties) {
    nameToCount.set(property.name, (nameToCount.get(property.name) ?? 0) + 1)
  }
  const propertySidToDisambiguatedName = new Map<string, string>()
  for (const property of properties) {
    const isNameDuplicated = (nameToCount.get(property.name) ?? 0) > 1
    propertySidToDisambiguatedName.set(
      property.sid,
      isNameDuplicated ? `${property.name} (${property.sid})` : property.name
    )
  }
  return propertySidToDisambiguatedName
}

export function clearLocalStoragePropertyRelatedValues() {
  localStorage?.removeItem(LocalStorageKey.PROPERTY_SID)
  localStorage?.removeItem(LocalStorageKey.PORTFOLIO_SID)
  localStorage?.removeItem(LocalStorageKey.RENEWALS_PROPERTY_SID)
}
